import React, { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { IoPersonSharp, IoLockClosedSharp } from "react-icons/io5";
import logo from "../../images/logo/we.png";

const SignIn = ({ onLogin }) => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(userName, password);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#f4f7fe] relative overflow-hidden font-['Outfit']">
      {/* Background Decorative Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-full blur-[120px] animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="w-full max-w-[440px] px-6 relative z-10 animate-fade-in">
        <div className="bg-white/80 backdrop-blur-2xl p-10 md:p-12 rounded-[2.5rem] shadow-2xl shadow-slate-200/60 border border-white/50">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-11 h-11 bg-primary rounded-xl flex items-center justify-center backdrop-blur-xl border border-white/10 group-hover/logo:scale-105 group-hover/logo:bg-white/15 transition-all duration-500 shadow-xl shadow-black/20 mb-4">
              <img src={logo} alt="Logo" className="w-8 h-8 object-contain opacity-90 brightness-0 invert" />
            </div>
            <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight mb-2">H-LINE CRM</h1>
            <p className="text-slate-500 font-medium">Elevating your business management</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">
                Username
              </label>
              <div className={`relative group transition-all duration-300 ${isFocused === "username" ? "scale-[1.02]" : ""}`}>
                <div className={`absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none transition-colors duration-300 ${isFocused === "username" ? "text-primary" : "text-slate-400"}`}>
                  <IoPersonSharp className="w-4 h-4" />
                </div>
                <input
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  onFocus={() => setIsFocused("username")}
                  onBlur={() => setIsFocused("")}
                  placeholder="Enter your username"
                  className={`w-full bg-white border-2 pl-11 pr-4 py-4 rounded-2xl outline-none transition-all duration-300 font-semibold placeholder:text-slate-300 placeholder:font-medium ${isFocused === "username"
                    ? "border-primary ring-4 ring-primary/5 shadow-lg shadow-primary/5"
                    : "border-slate-100 hover:border-slate-200"
                    }`}
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className={`relative group transition-all duration-300 ${isFocused === "password" ? "scale-[1.02]" : ""}`}>
                <div className={`absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none transition-colors duration-300 ${isFocused === "password" ? "text-primary" : "text-slate-400"}`}>
                  <IoLockClosedSharp className="w-4 h-4" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setIsFocused("password")}
                  onBlur={() => setIsFocused("")}
                  placeholder="••••••••"
                  className={`w-full bg-white border-2 pl-11 pr-12 py-4 rounded-2xl outline-none transition-all duration-300 font-semibold placeholder:text-slate-300 ${isFocused === "password"
                    ? "border-primary ring-4 ring-primary/5 shadow-lg shadow-primary/5"
                    : "border-slate-100 hover:border-slate-200"
                    }`}
                  required
                />
                <button
                  type="button"
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-primary transition-colors duration-300"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <IoMdEyeOff className="w-5 h-5" /> : <IoMdEye className="w-5 h-5" />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              className="w-full py-4.5 bg-primary text-white text-base font-bold rounded-2xl shadow-xl shadow-primary/30 hover:shadow-2xl hover:shadow-primary/40 hover:-translate-y-1 active:scale-95 transition-all duration-300 flex items-center justify-center gap-3 mt-4"
            >
              Sign In to CRM
              <span className="text-xl">→</span>
            </button>


          </form>
        </div>

        <div className="mt-8 text-center text-slate-400 text-xs font-bold uppercase tracking-[0.2em]">
          Powered by H-LINE
        </div>
      </div>
    </div>
  );
};

export default SignIn;
